<style src="css/evaluate.css" scoped></style>
<template>
    <div class="evaluateBox">
        <topbar text="评价" status="true"></topbar>
        <div class="docImg" :style="{background: `url(${EnvUrl}${chatDoctor.doctorWorkPhoto}) no-repeat center/cover`}"></div>
        <div class="docName">{{chatDoctor.doctorName}}</div>
        <div class="pj">您的评价会让咨询师做的更好！</div>
        <ul class="star">
            <li v-for="(item,index) in star" :class="{active:item.status}" @click="changeStar(index)"></li>
        </ul>
        <div class="starName">{{starName}}</div>
        <ul class="list">
            <li v-for="(item,index) in tabList" :class="{active:item.status}" @click="changeList(item.status,index)">
                {{item.name}}
            </li>
        </ul>
        <textarea v-model="content" name="" id="" cols="30" rows="10" placeholder="请您真实描述感受好的或不好的部分，帮助我们提升。"></textarea>
        <div class="btn" v-if="!chatQuestionComment.star" @click="handle()">提交评价</div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                content:'',
                scaleUserTestList: [],
                indexNum: -1,
                labelId: '',
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                testStatus: 0,
                userId: '',
                star:[
                    {
                        num:1,
                        status:false,
                        name:'非常不满意',
                        tab:[
                            {
                                name:'态度很差',
                                status:false,
                            },
                            {
                                name:'不专业',
                                status:false,
                            },
                            {
                                name:'完全听不懂',
                                status:false,
                            },
                            {
                                name:'回复太慢',
                                status:false,
                            },
                            {
                                name:'建议毫无效果',
                                status:false,
                            },
                        ]
                    },
                    {
                        num:2,
                        status:false,
                        name:'较不满意',
                        tab:[
                            {
                                name:'态度很差',
                                status:false,
                            },
                            {
                                name:'不专业',
                                status:false,
                            },
                            {
                                name:'完全听不懂',
                                status:false,
                            },
                            {
                                name:'回复太慢',
                                status:false,
                            },
                            {
                                name:'建议毫无效果',
                                status:false,
                            },
                        ]
                    },
                    {
                        num:3,
                        status:false,
                        name:'一般',
                        tab:[
                            {
                                name:'希望态度更好',
                                status:false,
                            },
                            {
                                name:'希望回复更快',
                                status:false,
                            },
                            {
                                name:'希望讲得更清楚',
                                status:false,
                            },
                        ]
                    },
                    {
                        num:4,
                        status:false,
                        name:'较满意',
                        tab:[
                            {
                                name:'态度非常好',
                                status:false,
                            },
                            {
                                name:'讲得很清楚',
                                status:false,
                            },
                            {
                                name:'非常专业',
                                status:false,
                            },
                            {
                                name:'回复很及时',
                                status:false,
                            },
                            {
                                name:'建议很有帮助',
                                status:false,
                            },
                        ]
                    },
                    {
                        num:5,
                        status:false,
                        name:'满意',
                        tab:[
                            {
                                name:'态度非常好',
                                status:false,
                            },
                            {
                                name:'讲得很清楚',
                                status:false,
                            },
                            {
                                name:'非常专业',
                                status:false,
                            },
                            {
                                name:'回复很及时',
                                status:false,
                            },
                            {
                                name:'建议很有帮助',
                                status:false,
                            },
                        ]
                    },
                ],
                starName:'点击星星评分',
                tabList:[],
                current:'',
                chatQuestionComment:{
                    content:'',
                },
                chatDoctor:{},
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isPayStatus(value){
                return ['','已支付'][value]
            }
        },
        computed: {},
        methods: {
            changeList(status,index){
                if(!this.chatQuestionComment.content){
                    this.tabList[index].status=!status;
                }

            },
            changeStar(index){
                if(!this.chatQuestionComment.content){
                    this.starName=this.star[index].name;
                    this.tabList=this.star[index].tab;
                    this.current=index+1;
                    this.star.forEach((v,i)=>{
                        if(i>index){
                            v.status=false;
                        }else{
                            v.status=true;
                        }
                    })
                }
            },
            selectLabel(index, id) {
                this.scaleInfoList = [];
                this.isLoading = false;
                this.indexNum = index;
                this.labelId = id;
                this.pageIndex = 1;
                let obj = {}
                if (index == -1) {
                    obj.recommendStatus = 1;
                } else {
                    obj.labelId = id;
                }
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                this.getScaleInfoList(serialize(obj))
            },
            handle(){
                if(!this.current){
                    alert(`请您选择星级`)
                }else{
                    let obj ={}
                    obj.content=this.content;
                    obj.doctorId=this.$route.query.doctorId;
                    obj.bespeakId=this.$route.query.bespeakId;
                    obj.userId=this.userId;
                    obj.star=this.current;
                    let aa=[]
                    this.star[this.current-1].tab.forEach(v=>{
                        if(v.status){
                            aa.push(v.name)
                        }
                    })
                    obj.tag=JSON.stringify(aa)
                    console.log(obj)
                    this.commitComment(obj)
                }

            },

            async commitComment(obj) {
                let data = await getSources("/bear-scale/api/chatQuestion/commitComment.json", obj);
                if (data.status === 0) {
//                    this.$router.push(`/${n}`)
                    history.back()
                }
            },
            async getCommentDetail() {
                let data = await getSources("/bear-scale/api/chatQuestion/getCommentDetail.json", {
                    bespeakId:this.$route.query.bespeakId,
                    doctorId:this.$route.query.doctorId
                });
                if (data.status === 0) {
                    this.chatDoctor = data.commentDetail.chatDoctor;
                    if(data.commentDetail.chatQuestionComment){
                        this.chatQuestionComment = data.commentDetail.chatQuestionComment;
                    }
                    if(this.chatQuestionComment.content){
                        this.star.forEach((v,i)=>{
                            if(i>this.chatQuestionComment.star-1){
                                v.status=false;
                            }else{
                                v.status=true;
                            }
                        })
                        this.content=this.chatQuestionComment.content
                        this.starName=this.star[this.chatQuestionComment.star-1].name
                        this.tabList=this.star[this.chatQuestionComment.star-1].tab
                        let aa=JSON.parse(this.chatQuestionComment.tag);
                        this.tabList.forEach(v=>{
                            aa.forEach(value=>{
                                if(v.name===value){
                                    v.status=true;
                                }
                            })
                        })
                    }
                }else{
                    alert(data.msg)
                }
            },
            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.getCommentDetail();
            this.userId=localStorage.getItem('userId')
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/evaluate.vue?58e675bc